export default __webpack_public_path__ + "static/media/018-coffee-shop.d9f26cb2.png";